import { useQuery } from '@tanstack/react-query';

import { getResellerPlace } from 'services';

export const useResellerPlace = () => {
  return {
    ...useQuery({
      queryKey: ['RESELLER_PLACES'],
      queryFn: getResellerPlace,
      retry: 1,
      staleTime: 2 * 60 * 1000,
      refetchOnWindowFocus: false,
    }),
  };
};
